module.exports = __webpack_public_path__ + "static/img/icon_logo2.59aa236.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/icon_logo2.png
// module id = 0bDm
// module chunks = 1